export default __webpack_public_path__ + "static/media/5.2492e020.jpeg";